export default "__VITE_ASSET__aEi8urYl__"